import {
  Button,
  Checkbox,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Table,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import customerApi from '../../api/customer.api'
import CrmDetailComponent from '../../components/customer/CrmHistoryDetailComponent'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/customer.module.scss'

const CrmHistoryPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [failStatus, setFailStatus] = useState([])
  const [dateType, setDateType] = useState('1week')
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [totalCrmHistoryList, setTotalCrmHistoryList] = useState([])
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [modalShow, setModalShow] = useState(false)
  const [selected, setSelected] = useState({})

  const [searchOptions, setSearchOptions] = useState({
    sendStatus: ['total'],
    startDate: dayjs().subtract(7, 'days').startOf('day'),
    endDate: dayjs().endOf('day'),
    phone: '',
    name: '',
  })
  const [sendList, setSendList] = useState([])

  const dateTypeItems = [
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
  ]
  const sendStatusItems = [
    { label: '전체', value: 'total' },
    { label: '성공', value: 'success' },
    { label: '대기', value: 'reservation' },
    { label: '실패', value: 'fail' },
  ]

  useEffect(() => {
    readFailStatus()
    getCrmHistoryList('initaial')
  }, [])

  useEffect(() => {
    setSendList(totalCrmHistoryList.slice(offset, offset + pageSize))
  }, [offset, pageSize])

  useEffect(() => {
    handleChangePagination(currentPageNumber)
  }, [pageSize])

  const readFailStatus = async () => {
    const res = await customerApi.crmFailList(user.id)
    if (res.data.code === 200) {
      setFailStatus(res.data.result)
    }
  }

  const getCrmHistoryList = async (
    type = '',
    sendStatus,
    startDate,
    endDate,
  ) => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          sendStatus: sendStatusItems[0].value,
          startDate: dayjs()
            .subtract(7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD'),
          endDate: dayjs().endOf('day').format('YYYY-MM-DD'),
          phone: '',
          name: '',
          userId: user.id,
        }
      } else if (type === 'search') {
        param = {
          sendStatus: searchOptions.sendStatus.join(','),
          startDate: searchOptions.startDate.format('YYYY-MM-DD'),
          endDate: searchOptions.endDate.format('YYYY-MM-DD'),
          phone: searchOptions.phone,
          name: searchOptions.name,
          userId: user.id,
        }
      } else if (type === 'custom') {
        param = {
          sendStatus: sendStatus,
          startDate: startDate.format('YYYY-MM-DD'),
          endDate: endDate.format('YYYY-MM-DD'),
          phone: searchOptions.phone,
          name: searchOptions.name,
          userId: user.id,
        }
      } else {
        param = {
          sendStatus: searchOptions.sendStatus.join(','),
          startDate: searchOptions.startDate.format('YYYY-MM-DD'),
          endDate: searchOptions.endDate.format('YYYY-MM-DD'),
          phone: searchOptions.phone,
          name: searchOptions.name,
          userId: user.id,
        }
      }
      const res = await customerApi.searchCrmHistoryList(param, user.id)
      if (res.data.code === 200) {
        if (res.data.result) {
          setTotalCrmHistoryList(res.data.result)
        } else {
          setTotalCrmHistoryList([])
        }
        if (type === 'initial' || type === 'search') {
          setSendList(res.data.result.slice(0, 10))
        } else {
          setSendList(res.data.result.slice(offset, offset + pageSize))
        }
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getCrmHistoryList read error = ', error)
    }
  }

  const handleDateTypeChange = (e) => {
    const value = e.target.value
    setDateType(value)
    switch (value) {
      case 'today':
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
      case '6month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(6, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(6, 'months')
              .startOf('day'),
          })
        }
        break
    }
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record, selected) => {
      let editKeyList = []
      let editRowList = []
      if (selected) {
        const filterList = sendList.filter((item) => item.id === record.id)
        const filterKeyList = filterList.map((row) => row.id)
        editRowList = [...selectedRow, ...filterList]
        editKeyList = [...selectedRowKey, ...filterKeyList]
      } else {
        editRowList = selectedRow.filter((item) => item.id !== record.id)
        editKeyList = editRowList.map((row) => row.id)
      }
      setSelectedRowKey(editKeyList)
      setSelectedRow(editRowList)
    },
  }

  const columns = [
    {
      title: '발송타입',
      // width: 100,
      dataIndex: 'templateCategory',
      key: 'templateCategory',
      // fixed: 'left',
      // ellipsis: true,
      // sorter: (a, b) => {}
      render: (value, record) => {
        if (
          record.hasOwnProperty('crmHistoryList') &&
          record.crmHistoryList?.length > 0
        ) {
          let sendType = '기타'
          if (record.templateTitle) {
            if (record.templateTitle.includes('ORDER_DEPOSIT_REQUEST')) {
              sendType = `무통장 입금대기 ${record.templateTitle.replace(
                'ORDER_DEPOSIT_REQUEST_',
                '',
              )}일차`
            } else if (
              record.templateTitle.includes('VIRTUAL_ACCOUNT_REQUEST')
            ) {
              sendType = `가상계좌 입금대기 ${record.templateTitle.replace(
                'VIRTUAL_ACCOUNT_REQUEST_',
                '',
              )}일차`
            } else if (value) {
              sendType = record?.templateTitle
            }
          }
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <span>
                {record.hasOwnProperty('crmHistoryList') &&
                record.crmHistoryList[0].isManual
                  ? '직접발송'
                  : '자동발송'}
              </span>
              <span
                className={`gray-font`}
                style={{
                  position: 'relative',
                }}
              >
                <div
                  className={`${styles['point-div']}`}
                  style={
                    record.failCnt
                      ? {
                          backgroundColor: '#fe2b4b',
                        }
                      : record.reservationCnt
                        ? {
                            backgroundColor: '#ff8000',
                          }
                        : {
                            backgroundColor: '#7ad629',
                          }
                  }
                />
                {sendType}
              </span>
            </div>
          )
        }
      },
    },
    {
      title: '발송시간',
      // width: 120,
      dataIndex: 'createdAt',
      key: 'createdAt',
      // ellipsis: true
      render: (value, record) => {
        if (
          record.hasOwnProperty('crmHistoryList') &&
          record.crmHistoryList?.length > 0
        ) {
          if (record.crmHistoryList[0].crmSendDate) {
            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <span>
                  {dayjs(record.crmHistoryList[0].crmSendDate).format(
                    'YYYY.MM.DD',
                  )}
                </span>
                <span className={`gray-font`}>
                  {dayjs(record.crmHistoryList[0].crmSendDate).format(
                    'HH:mm:ss',
                  )}
                </span>
              </div>
            )
          } else {
            if (value) {
              return (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <span>{dayjs(value).format('YYYY.MM.DD')}</span>
                  <span className={`gray-font`}>
                    {dayjs(value).format('HH:mm:ss')}
                  </span>
                </div>
              )
            }
          }
        } else {
          if (value) {
            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <span>{dayjs(value).format('YYYY.MM.DD')}</span>
                <span className={`gray-font`}>
                  {dayjs(value).format('HH:mm:ss')}
                </span>
              </div>
            )
          }
        }
      },
    },
    {
      title: '메시지 내용',
      width: 280,
      dataIndex: 'message',
      key: 'message',
      // ellipsis: true
      render: (_, record) => {
        if (
          record.hasOwnProperty('crmHistoryList') &&
          record.crmHistoryList?.length > 0
        ) {
          return (
            <span className={`ellipse-font`} style={{ textAlign: 'left' }}>
              {record.crmHistoryList[0].crmMessage}
            </span>
          )
        }
      },
    },
    {
      title: '메시지 유형',
      // width: 120,
      dataIndex: 'templateType',
      key: 'templateType',
      // ellipsis: true
      render: (value) => {
        if (value === 'NOTIFICATION') {
          return '카카오 알림톡'
        } else if (value === 'FRIENDLY') {
          return '카카오 친구톡'
        } else if (value === 'MESSAGE') {
          return '문자'
        } else {
          return '문자'
        }
      },
    },
    {
      title: '발송건수',
      // width: 120,
      dataIndex: 'totalCnt',
      key: 'totalCnt',
      // ellipsis: true
    },
    {
      title: '성공',
      // width: 120,
      dataIndex: 'successCnt',
      key: 'successCnt',
      // ellipsis: true
    },
    {
      title: '실패',
      // width: 120,
      dataIndex: 'failCnt',
      key: 'failCnt',
      // ellipsis: true
      render: (value) => {
        if (value === 0) {
          return <span>{value}</span>
        } else {
          return (
            <span
              style={{
                color: '#fe2b4b',
                fontWeight: 'bold',
              }}
            >
              {value}
            </span>
          )
        }
      },
    },
    {
      title: '대기',
      // width: 120,
      dataIndex: 'reservationCnt',
      key: 'reservationCnt',
      // ellipsis: true
      render: (value) => {
        if (value === 0) {
          return <span>{value}</span>
        } else {
          return (
            <span
              style={{
                color: '#ff8000',
                fontWeight: 'bold',
              }}
            >
              {value}
            </span>
          )
        }
      },
    },
    {
      title: '수신자명',
      // width: 120,
      dataIndex: 'name',
      key: 'name',
      // ellipsis: true
      render: (_, record) => {
        if (
          record.hasOwnProperty('crmHistoryList') &&
          record.crmHistoryList?.length > 0
        ) {
          return record.crmHistoryList[0]?.targetName
        }
      },
    },
    {
      title: '수신번호',
      // width: 120,
      dataIndex: 'phone',
      key: 'phone',
      // ellipsis: true
      render: (_, record) => {
        if (
          record.hasOwnProperty('crmHistoryList') &&
          record.crmHistoryList?.length > 0
        ) {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <span>{record.crmHistoryList[0].targetPhone}</span>
              {record.crmHistoryList?.length > 1 && (
                <span className={`gray-font`}>
                  외 {record.crmHistoryList?.length - 1}건
                </span>
              )}
            </div>
          )
        }
      },
    },
    {
      title: '',
      // width: 120,
      dataIndex: '',
      key: '',
      // ellipsis: true
      render: (_, record) => {
        if (record.reservationCnt) {
          return (
            <button
              className="crm-send-btn"
              onClick={(e) => {
                e.stopPropagation()
                handleSendClick(record)
              }}
            >
              발송
            </button>
          )
        }
      },
    },
  ]

  /**
   * 전송 실패 click handler
   */
  const handleFailClick = () => {
    let startDate = dayjs().subtract(7, 'days').startOf('day')
    let endDate = dayjs().endOf('day')
    if (failStatus.length) {
      startDate = dayjs(failStatus[failStatus?.length - 1].updatedAt).startOf(
        'day',
      )
      endDate = dayjs(failStatus[0].updatedAt).endOf('day')
      setDateType('')
    } else {
      setDateType('1week')
    }
    setSearchOptions({
      ...searchOptions,
      phone: '',
      name: '',
      sendStatus: ['fail'],
      startDate: startDate,
      endDate: endDate,
    })
    getCrmHistoryList('custom', 'fail', startDate, endDate)
  }

  /**
   * 전송 상태 click handler
   */
  const handleSearchOptionChange = (e) => {
    const { value, checked } = e.target
    let currSendStatus = searchOptions.sendStatus
    if (value === 'total') {
      if (checked) {
        currSendStatus = [value]
      }
    } else {
      if (checked) {
        currSendStatus.push(value)
        if (currSendStatus.includes('total')) {
          currSendStatus = currSendStatus.filter((item) => item !== 'total')
        }
      } else {
        currSendStatus = currSendStatus.filter((item) => item !== value)
        if (currSendStatus?.length === 0) {
          currSendStatus = ['total']
        }
      }
    }
    setSearchOptions({
      ...searchOptions,
      sendStatus: currSendStatus,
    })
  }

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
        )
      } else {
        setOffset(0)
        setPageSize(10)
        setCurrentPageNumber(1)
        getCrmHistoryList('search')
      }
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      sendStatus: ['total'],
      name: '',
      phone: '',
      startDate: dayjs().subtract(7, 'days').startOf('day'),
      endDate: dayjs().endOf('day'),
    })
    setDateType(dateTypeItems[1].value)
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    setSelectedRowKey([])
    setSelectedRow([])
    getCrmHistoryList('initial')
  }

  /**
   * 예약건 발송처리 click handler (2023.03.20) - ksb
   */
  const handleSendClick = async (record) => {
    const filteredList = record.crmHistoryList.filter(
      (crmHistory) => crmHistory.crmIsSend === 'RESERVATION',
    )
    if (
      window.confirm(
        `${filteredList[0]?.targetName}님${
          filteredList?.length > 1
            ? ` 외 ${filteredList?.length - 1}건을`
            : '에게'
        } CRM을 전송하시겠습니까?\n"확인"을 누를시, 최대 5분 이내에 자동으로 전송됩니다.`,
      )
    ) {
      setIsLoading(true)
      try {
        const param = {
          crmIdList: filteredList.map((crmHistory) => crmHistory.id),
          userId: user.id,
        }
        const res = await customerApi.changeCRMListToWait(param)
        if (res.data.code === 200) {
          alert(
            `총 ${res.data.result}건 발송 예약 처리되었습니다.\n5분 이후에 확인해주세요!`,
          )
          handleInitialBtnClick()
        } else {
          throw res.data.msg
        }
        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
        alert(e)
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(currOffset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset((current - 1) * pageSize)
  }

  return (
    <>
      <ContentHeader title="CRM 내역" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }} // TODO: 사이즈 고려 중
      >
        <Row className={`${styles['product-search-product-status-wrap']}`}>
          {/*취소요청*/}
          <Col md={5}>
            <Row
              className={`${styles['product-status-box-wrap']}`}
              align={'middle'}
            >
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/customer/sendFail.png`}
                alt={`전송실패`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>전송실패</div>
                <div onClick={handleFailClick} style={{ cursor: 'pointer' }}>
                  <span
                    className={`${styles['product-status-num']}`}
                    style={{
                      color: '#fe2b4b',
                    }}
                  >
                    {failStatus?.length}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>
        {/*CRM 내역 검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            className={`${styles['center-label']}`}
            label="전송상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            {sendStatusItems.map((item, idx) => (
              <Checkbox
                key={`send_status_${idx}`}
                name="sendStatus"
                value={item.value}
                onChange={handleSearchOptionChange}
                checked={searchOptions.sendStatus.includes(item.value)}
              >
                {item.label}
              </Checkbox>
            ))}
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row
                align={'middle'}
                style={{ marginTop: 10, rowGap: '1rem', gap: 5 }}
              >
                <span
                  className="another-gray-font"
                  style={{ marginRight: '1rem' }}
                >
                  전송일
                </span>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <Row align={'middle'} style={{ rowGap: '1rem', gap: '1rem' }}>
                  <DatePicker
                    className={`${styles['order-search-date-wrap']}`}
                    format="YYYY/MM/DD"
                    allowClear={false}
                    value={searchOptions.startDate}
                    onChange={(value) => {
                      setDateType('')
                      setSearchOptions({ ...searchOptions, startDate: value })
                    }}
                  />
                  ~
                  <DatePicker
                    className={`${styles['order-search-date-wrap']}`}
                    format="YYYY/MM/DD"
                    allowClear={false}
                    value={searchOptions.endDate}
                    onChange={(value) => {
                      setDateType('')
                      setSearchOptions({ ...searchOptions, endDate: value })
                    }}
                  />
                </Row>
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={'middle'} style={{ rowGap: '1rem', gap: '1rem' }}>
              <div className={`${styles['input-div']}`}>
                <span className="another-gray-font">수신번호</span>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) => {
                    setSearchOptions({
                      ...searchOptions,
                      phone: e.target.value,
                    })
                  }}
                  placeholder={`수신번호`}
                  onPressEnter={handleSearch}
                />
              </div>
              <div className={`${styles['input-div']}`}>
                <span className="another-gray-font">수신자명</span>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) => {
                    setSearchOptions({
                      ...searchOptions,
                      name: e.target.value,
                    })
                  }}
                  placeholder={`수신자명`}
                  onPressEnter={handleSearch}
                />
              </div>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['inquiry-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['inquiry-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['inquiry-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              전송 목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalCrmHistoryList?.length}
              </span>
              개)
            </span>
          </div>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={sendList}
            loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="id"
            className={`${styles['table-class']}`}
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: 'max-content' }}
            // onChange={handleTableChange}
            pagination={false}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  setSelected(record)
                  setModalShow(true)
                },
              }
            }}
          />

          <Pagination
            showSizeChanger
            pageSize={pageSize}
            onShowSizeChange={pageSizeChange}
            total={totalCrmHistoryList?.length}
            onChange={handleChangePagination}
            align="end"
            style={{ marginTop: 20 }}
            current={currentPageNumber}
          />
        </div>
      </div>
      {modalShow && (
        <Modal
          title="전송 상세보기"
          wrapClassName="order-detail-modal-wrap"
          open={modalShow}
          centered={true}
          onCancel={() => {
            setModalShow(!modalShow)
            setSelected({})
          }}
          footer={null}
          width="70%"
        >
          <CrmDetailComponent
            crm={selected}
            handleModalCancel={() => {
              setModalShow(!modalShow)
              setSelected({})
            }}
            getCrmHistoryList={getCrmHistoryList}
          />
        </Modal>
      )}
    </>
  )
}

export default CrmHistoryPage
